import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'content',
  children: {
    builder: {
      path: 'builder',
    },
  },
} as const satisfies Location
